import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import companyLogo from "./../../../assets/images/logo.png";
import $ from "jquery";
import NetworkStatus from "../../../utils/networkStatus";
import { header_web } from "../../../locales/en";
import { LOGIN } from "../../../route/paths";
import { FUNDTAPAUURL } from "../../../utils/constants/appConstants";

const Headerweb = () => {
  // Navbar Toggle
  const [isNavVisible, setIsNavVisible] = useState(false);
  const { referralCode } = useParams();

  const toggleNavVisibility = () => {
    $(".nav-trigger").toggleClass("trigger-close");
    setIsNavVisible(!isNavVisible);
  };

  const handleNavLinkClick = () => {
    $(".nav-trigger").removeClass("trigger-close");
    setIsNavVisible(false);
  };

  // Sticky Navbar
  const [sticky, setSticky] = useState(false);
  const handleStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar);

    handleStickyNavbar();

    return () => {
      window.removeEventListener("scroll", handleStickyNavbar);
    };
  }, []);

  return (
    <>
      <header className={`header ${sticky ? "sticky" : ""}`}>
        <div className="header-wrap">
          <div className="container-wrap">
            <div className="row-flex">
              <Link
                className="barnding"
                to={FUNDTAPAUURL}
                onClick={handleNavLinkClick}
              >
                <div className="balck-logo">
                  <img
                    src={companyLogo}
                    alt="barnding-logo"
                    width={213}
                    height={48}
                  />
                </div>
              </Link>
              <div className={`navbar-main ${isNavVisible ? "visible" : ""}`}>
                <ul className="login-group">
                  <li>
                    <Link
                      to={LOGIN}
                      className="border-btn-primary"
                      onClick={handleNavLinkClick}
                    >
                      {header_web?.link6}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={
                        referralCode
                          ? `/sign-up?referral_code=${referralCode}`
                          : "/sign-up"
                      }
                      className="btn-primary icon-with-btn"
                      onClick={handleNavLinkClick}
                    >
                      {header_web?.link7}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="nav-trigger" onClick={toggleNavVisibility}>
                <span className="bar-1" />
                <span className="bar-2" />
                <span className="bar-3" />
              </div>
            </div>
          </div>
        </div>
      </header>
      <NetworkStatus />
    </>
  );
};

export default Headerweb;
